export default __webpack_public_path__ + "static/media/salon.fca5fc88.jpg";